// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Gift, DiscountShape, TickCircle, Chart21, Link2 } from 'iconsax-react';

// icons — one relevant icon per destination
const icons = {
  traders: Gift,
  dashboard: Chart21,
  redemptions: DiscountShape,
  rcMapping: Link2,
  approvals: TickCircle,
};

// ==============================|| MENU ITEMS - TRADERS PROGRAM ||============================== //
// Trader-facing incentive programs and their redemptions.

const traders = {
  id: 'group-traders-program',
  title: <FormattedMessage id="Traders Program" />,
  icon: icons.traders,
  type: 'group',
  children: [
    {
      id: 'traders-dashboard',
      title: <FormattedMessage id="Dashboard" />,
      type: 'item',
      icon: icons.dashboard,
      url: '/traders/dashboard',
    },
    {
      id: 'incentive-redemptions',
      title: <FormattedMessage id="Incentive Redemptions" />,
      type: 'item',
      icon: icons.redemptions,
      url: '/traders/incentive-redemptions',
    },
    {
      id: 'traders-rc-mapping',
      title: <FormattedMessage id="RC Mapping" />,
      type: 'item',
      icon: icons.rcMapping,
      url: '/traders/rc-mapping',
    },
    {
      id: 'traders-approvals',
      title: <FormattedMessage id="Approvals" />,
      type: 'item',
      icon: icons.approvals,
      url: '/traders/approvals',
    },
  ],
};

export default traders;
